module.exports = __webpack_public_path__ + "static/img/avatar-s-14.9ab8c514.png";